import React, { Component } from 'react';
import { Grid, FormHelperText } from '@material-ui/core';
import { CheckBox } from '..';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles';

class Disclaimer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, mightyMeals } = this.props;
    return (
      <Grid>
        <Grid className={classes.formGroup1}>
          <CheckBox {...this.props} />
          <span className={mightyMeals ? classes.mightyDisc : ''}>
            I have read and understand the{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={this.props.event.disclaimer}
            >
              terms and conditions{' '}
            </a>
          </span>
        </Grid>

        <FormHelperText className={classes.helperText}>
          {this.props.hasError && this.props.hasError(this.props.name)
            ? this.props.errors && this.props.errors.you_must_agree[0]
            : ''}
        </FormHelperText>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(Disclaimer);
